import { _ as _applyDecoratedDescriptor, a as _initializerDefineProperty } from '../_rollupPluginBabelHelpers-3b0ba74f.js';
import BaseHelper from 'ember-intl/helpers/format-number';
import { inject } from '@ember/service';
import { normalizeCurrency } from 'beebee-base/lib/utility';
import currency from 'beebee-base/lib/currency-core';

var _class, _descriptor, _descriptor2;
const DEFAULT_CURRENCY = 'EUR';

/**
 * Helper per formattare valori in valuta
 */
let FormatEuroHelper = (_class = class FormatEuroHelper extends BaseHelper {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "session", _descriptor, this);
    _initializerDefineProperty(this, "intl", _descriptor2, this);
  }
  compute([number, valuta]) {
    // Normalizza null/undefined a 0
    number = number ?? 0;
    // Determina la valuta da usare
    const currencyCode = valuta || this.session.option_field?.intl?.currency || DEFAULT_CURRENCY;

    // Converti la stringa in numero se necessario
    let numericValue = number;
    if (typeof number === 'string') {
      const hasComma = number.includes(',');
      numericValue = hasComma ? currency(number, {
        decimal: ','
      }).value : currency(number).value;
    }
    return this.intl.formatNumber(numericValue, {
      style: 'currency',
      currency: normalizeCurrency(currencyCode)
    });
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "session", [inject], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "intl", [inject], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);

export { FormatEuroHelper as default };
//# sourceMappingURL=format-euro.js.map
